import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { RailItem } from './workflowNav';
import { useProjectWorkflow } from '../../contexts/ProjectWorkflowContext';

interface IconRailProps {
  items: RailItem[];
  disabled?: boolean;
}

const IconRail: React.FC<IconRailProps> = ({ items, disabled = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { clearProject, setNavTarget, setPanelOpen } = useProjectWorkflow();

  const handleNav = (item: RailItem) => {
    if (disabled && item.id !== 'home' && item.id !== 'clients') return;
    setNavTarget(item.id);
    clearProject();
    if (item.id === 'home' || item.id === 'clients' || item.id === 'projects') {
      setPanelOpen(true);
    } else {
      setPanelOpen(false);
    }
    navigate(item.path);
  };

  const isActive = (item: RailItem) => {
    if (item.id === 'home') return location.pathname === '/dashboard';
    return location.pathname.startsWith(item.path);
  };

  const mainItems = items.filter((i) => i.section !== 'bottom');
  const bottomItems = items.filter((i) => i.section === 'bottom');

  const renderBtn = (item: RailItem) => {
    const active = isActive(item);
    const isDisabled = disabled && item.id !== 'home' && item.id !== 'clients';
    return (
      <Tooltip key={item.id} title={item.tooltip || item.label} placement="right">
        <button
          type="button"
          disabled={isDisabled}
          onClick={() => handleNav(item)}
          className={`wf-rail-btn${active ? ' on' : ''}`}
          style={{
            opacity: isDisabled ? 0.4 : 1,
            cursor: isDisabled ? 'not-allowed' : 'pointer',
          }}
        >
          <span className="wf-rail-icon">{item.icon}</span>
          <span className="wf-rail-label">{item.label}</span>
          {item.badge != null && item.badge > 0 && (
            <span className="wf-rail-badge">{item.badge > 99 ? '99+' : item.badge}</span>
          )}
        </button>
      </Tooltip>
    );
  };

  return (
    <aside className="wf-rail">
      <div className="wf-rail-logo">LM</div>
      <div className="wf-rail-divider" />
      <div className="wf-rail-main">{mainItems.map(renderBtn)}</div>
      {bottomItems.length > 0 && (
        <>
          <div className="wf-rail-divider" />
          <div className="wf-rail-bottom">{bottomItems.map(renderBtn)}</div>
        </>
      )}
    </aside>
  );
};

export default IconRail;
